// extracted by mini-css-extract-plugin
module.exports = {"styles":"styles___tI4-7","total":"total___14Aui","Content":"Content___3voFu","bottomPadding":"bottomPadding___19yfX"};